import { useState, Fragment } from "react";
import { Form, Input, Button, message } from "antd";
import { ExamLabel } from "../../components/commons";
import { storeParticipanteAcount } from "../../api/participante";
import { Link, useHistory } from "react-router-dom";
import * as SHARED from "../../utils/shared";

const ParticipanteReenviarContrasenia = () => {
  const history = useHistory();

  const [isSending, setIsSending] = useState(false);

  const onFinish = (values) => {
    const { email, cargo: idtipoparticipante } = values;
    sendPassword({ email, idtipoparticipante });
  };

  const sendPassword = async (data) => {
    try {
      setIsSending(true);
      const response = await storeParticipanteAcount(data);
      if (response) {
        setIsSending(false);
        message.success(response.message);
        history.push("/");
      }
    } catch (err) {
      setIsSending(false);
      message.error(err.message);
    }
  };

  return (
    <Fragment>
      <div className="max-w-xs mx-auto">
        <p className="mb-11"></p>
        <ExamLabel
          firstTitle="Olvidé mi contraseña"
          mainTitle={SHARED.PROCESO}
          style={{ background: "#D41D3D" }}
        />
      </div>
      <Form
        initialValues={{ remember: true }}
        onFinish={onFinish}
        className="max-w-xs mx-auto text-center"
        layout="vertical"
      >
        <Form.Item
          name="email"
          label="Ingrese su correo electrónico institucional:"
          rules={[{ required: true, message: "El correo electrónico es necesario" }]}
        >
          <Input placeholder="Correo electrónico institucional" type="email" />
        </Form.Item>

        <div
          className={`bg-gray-100 border-t-4 mb-8 rounded-b text-teal-900 px-4 py-3 shadow-md`}
          role="alert"
        >
          <div className="text-center">
            <p className="text-sm">
              RECUERDE QUE DEBE INGRESAR SU CORREO INSTITUCIONAL PARA RECIBIR LA CONTRASEÑA
            </p>
            <p>
              <b>Ejemplo: jperezh@unjbg.edu.pe</b>
            </p>
          </div>
        </div>

        <Form.Item>
          <Button type="primary" block loading={isSending} htmlType="submit">
            Reenviar contraseña
          </Button>
        </Form.Item>

        <Link to="/">
          <Button className="mb-2" type="link" block>
            Regresar a Iniciar sesión
          </Button>
        </Link>
      </Form>
    </Fragment>
  );
};

export default ParticipanteReenviarContrasenia;
